import { Box, Grid, GridItem } from '@chakra-ui/react'
import SettingsSidebar from './SettingsSidebar'

const SettingsLayout = ({ children }) => {
  return (
    <Grid templateColumns="250px 1fr" gap={6}>
      <GridItem>
        <SettingsSidebar />
      </GridItem>
      <GridItem>
        <Box bg="white" p={6} borderRadius="md" shadow="sm">
          {children}
        </Box>
      </GridItem>
    </Grid>
  )
}

export default SettingsLayout